import {
  generateLanguageQuery,
  optionalI18nString,
  optionalImage,
  resourcesArray,
  tipsArray
} from '@/services/dataStore/queries/fragments'

const effectProjection = (isReferenceArticle: boolean) => `
  'key': _id,
  'nameI18n': ${generateLanguageQuery('name')},
  'definitionI18n': ${generateLanguageQuery('definition')},
  ${optionalImage('icon')},
  sortOrder,
  'deprecated': deprecated == true,
  'category': category->{
    'id': _id,
    'name': ${generateLanguageQuery('name')},
    sortOrder,
    categoryColor,
    categoryTextColor,
    progressHoverColor
  },
  ${
    isReferenceArticle
      ? `
        ${optionalI18nString('longDescription', 'longDescriptionI18n')},
        ${optionalImage('hero')},
        ${tipsArray},
        ${resourcesArray}
      `
      : ''
  }
`

export const effectsQuery = () =>
  `*[_type == "effect"] {
    ${effectProjection(false)}
  }`

export const effectReferenceQuery = (effectKey: string) =>
  `*[_type == "effect" && _id == "${effectKey}"] {
    ${effectProjection(true)}
  }`
